// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1573":"6e5bfdf5425350f3","5322":"75045c48f6a10160","6972":"5c72837ffd79a769"}[chunkId] + ".js";
};